import React from 'react';
import './Mask.scss';

const Mask = () => {
  return <div className="maskStyle" />;
};

export default Mask;



// WEBPACK FOOTER //
// ./src/components/atoms/Mask/Mask.js